import type { Level } from '../engine/level';

const KEY = 'tile-path.v1';
export type Rec = { best: number; stars?: number };
export type Progress = { levels: Record<string, Rec>; last: string };

function storage(): Storage | null { try { return typeof localStorage !== 'undefined' ? localStorage : null; } catch { return null; } }

export function loadProgress(s: Pick<Storage, 'getItem'> | null = storage()): Progress {
  const empty: Progress = { levels: {}, last: 'beginner-1' };
  if (!s) return empty;
  try {
    const raw = s.getItem(KEY);
    if (!raw) return empty;
    const j = JSON.parse(raw) as Partial<Progress>;
    const levels: Record<string, Rec> = {};
    for (const [id, r] of Object.entries(j.levels ?? {})) {
      if (r && typeof r === 'object' && Number.isFinite((r as Rec).best)) levels[id] = { best: (r as Rec).best, ...(Number.isFinite((r as Rec).stars) ? { stars: (r as Rec).stars } : {}) };
    }
    return { levels, last: typeof j.last === 'string' ? j.last : empty.last };
  } catch { return empty; }
}
export function saveProgress(p: Progress, s: Pick<Storage, 'setItem'> | null = storage()): void {
  if (!s) return;
  try { s.setItem(KEY, JSON.stringify(p)); } catch { /* 저장 불가 — 무시 */ }
}
export function markCleared(p: Progress, id: string, moves: number, stars?: number): Progress {
  const prev = p.levels[id];
  const rec: Rec = { best: prev ? Math.min(prev.best, moves) : moves };
  const s = Math.max(prev?.stars ?? 0, stars ?? 0);
  if (s > 0) rec.stars = s;
  return { levels: { ...p.levels, [id]: rec }, last: id };
}

export function isAdmin(): boolean { try { return new URLSearchParams(location.search).get('stage') === 'all'; } catch { return false; } }

/** 같은 팩 안에서 깬 판 다음까지만(목록 순서). */
export function isUnlocked(p: Progress, level: Level, all: Level[]): boolean {
  if (isAdmin()) return true;
  const same = all.filter((l) => l.pack === level.pack).sort((a, b) => a.n - b.n);
  const idx = same.findIndex((l) => l.id === level.id);
  const maxIdx = same.reduce((m, l, i) => (p.levels[l.id] ? Math.max(m, i) : m), -1);
  return idx <= maxIdx + 1;
}
